// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"3bbc9a2d","467":"3bbc9a2d","606":"b92afa19","752":"2c223695","778":"3bbc9a2d","818":"fa2edb0d","876":"417dfbcc","903":"3bbc9a2d","934":"2c223695"}[chunkId] + ".chunk.css";
};